import React from "react"
import { Link, graphql, PageProps } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

type Data = {
  allMdx: {
    edges: {
      node: {
        frontmatter: {
          title: string
          date: string
        }
        fields: {
          slug: string
        }
      }
    }[]
  }
}

const UnfilteredPage = ({ data }: PageProps<Data>) => {
  const posts = data.allMdx.edges

  return (
    <Layout activePage="unfiltered">
      <SEO title="Unfiltered" />
      <div className="container">
        <div className="page-header fade-hero">
          <div className="page-eyebrow">01 — UNFILTERED</div>
          <div className="page-title">Unfiltered</div>
          <div className="page-desc">
            Hot takes, half-formed ideas, and things I keep thinking about. AI, internet
            culture, B2B growth — no filter.
          </div>
        </div>

        {posts.length === 0 ? (
          <div className="empty-state fade-content">
            nothing here yet
            <p>check back soon.</p>
          </div>
        ) : (
          <div className="entry-list fade-content">
            {posts.map(({ node }) => (
              <Link key={node.fields.slug} className="entry" to={node.fields.slug}>
                <div className="entry-meta">{node.frontmatter.date}</div>
                <div className="entry-title">{node.frontmatter.title}</div>
              </Link>
            ))}
          </div>
        )}

      </div>
    </Layout>
  )
}

export default UnfilteredPage

export const pageQuery = graphql`
  query {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { collection: { eq: "blog" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMM DD, YYYY")
            title
          }
        }
      }
    }
  }
`
